module.exports = __webpack_public_path__ + "img/P1-en.013bc372.png";